import { render, staticRenderFns } from "./type-schilderwerk.vue?vue&type=template&id=53fb403e"
import script from "./type-schilderwerk.vue?vue&type=script&lang=js"
export * from "./type-schilderwerk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports